import React from 'react';
import { motion } from 'framer-motion';
import { Menu, Bell, Search, User } from 'lucide-react';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { FONT_FAMILY } from "../../common/sharedFunctions";

const ModernHeader = ({ onMenuClick }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir();
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const navigate = useNavigate();

  const profile = auth?.profile || {};
  const displayName = profile.firstName ? `${profile.firstName} ${profile.lastName || ''}` : 'User';
  const userRole = profile.usertype ? profile.usertype.charAt(0).toUpperCase() + profile.usertype.slice(1) : '';

  return (
    <motion.header
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="sticky top-0 z-30 bg-white border-b border-gray-100"
      style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}
    >
      <div className="flex items-center justify-between h-16 px-4 lg:px-6">
        {/* Left */}
        <div className="flex items-center gap-3">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 hover:bg-gray-100 rounded-2xl transition-colors"
          >
            <Menu className="w-5 h-5 text-gray-600" />
          </button>
          <img
            src="/gruwcer-logo.png"
            alt="Gruwcer Delivery"
            onClick={() => navigate('/')}
            className="h-8 w-auto object-contain cursor-pointer hover:opacity-80 transition-opacity hidden sm:block"
            style={{ fontFamily: FONT_FAMILY }}
          />
        </div>

        {/* Right */}
        <div className="flex items-center gap-2">
          {/* Notifications */}
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="relative p-2.5 hover:bg-gray-100 rounded-xl transition-colors"
          >
            <Bell className="w-[18px] h-[18px] text-gray-500" />
            <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full ring-2 ring-white" />
          </motion.button>

          {/* Divider */}
          <div className="w-px h-8 bg-gray-200 mx-1" />

          {/* User */}
          <motion.div
            whileHover={{ scale: 1.01 }}
            onClick={() => navigate('/profile')}
            className="flex items-center gap-2.5 px-3 py-1.5 rounded-xl hover:bg-gray-50 cursor-pointer transition-colors"
          >
            <div className="w-8 h-8 rounded-full bg-gradient-to-r from-[#009689] to-[#319F44] flex items-center justify-center shadow-sm">
              {profile.profile_image ? (
                <img src={profile.profile_image} alt="" className="w-8 h-8 rounded-full object-cover" />
              ) : (
                <User className="w-4 h-4 text-white" />
              )}
            </div>
            <div className="hidden md:block">
              <p className="text-sm font-semibold text-gray-800 leading-tight" style={{ fontFamily: FONT_FAMILY }}>{displayName}</p>
              <p className="text-[11px] text-gray-500 leading-tight" style={{ fontFamily: FONT_FAMILY }}>{userRole}</p>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.header>
  );
};

export default ModernHeader;
